import { Button, Card, Space, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import OrangeEyeIcon from "../../../assets/icons/OrangeEyeIcon";
import PayrollImportOutlined from "../../../assets/icons/PayrollImportOutlined";
import AvatarImage from "../../../assets/images/empty-without-text.svg";
import BalanceSlide from "../../../components/common/BalanceSlide";
import CustomTable from "../../../components/ui/CustomTable";
import Loader from "../../../components/ui/Loader";
import { useGetSingleCompanyQuery } from "../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useBalanceCheckQuery,
  useGetAllVendorBatchQuery,
} from "../../../features/portal/vendorPayment/vendorPaymentApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { GetAllVendorDataType } from "../../../types/portal/vendorPayment";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";
import PayrollImportModal from "./PayrollImportModal";

export default function PayrollBatchList() {
  const { user, role } = useAppSelector((state) => state.auth);
  const { page, limit, handlePagination, handleLimit } = useTable();
  const { open, handleOpen, handleClose } = useModal();
  const { isLoading, isError, error, data } = useGetAllVendorBatchQuery({
    params: {
      company_id: user?.data?.company_id,
    },
  });
  const {
    isLoading: isCompanyDetailsLoading,
    isError: isCompanyDetailsError,
    error: companyDetailsError,
    data: companyDetails,
  } = useGetSingleCompanyQuery(user?.data?.company_id, {
    skip: !user?.data?.company_id,
  });
  const {
    isLoading: isBalanceCheckLoading,
    isError: isBalanceCheckError,
    error: balanceCheckError,
    data: balanceCheck,
  } = useBalanceCheckQuery(
    {
      walletNumber: companyDetails?.data?.wallet_number || "",
      companyId: user?.data?.company_id,
    },
    {
      skip: !companyDetails?.data?.wallet_number || !user?.data?.company_id,
    }
  );
  useError(isError, error, "Get vendor list fail");
  useError(isCompanyDetailsError, companyDetailsError, "Get company data fail");
  useError(isBalanceCheckError, balanceCheckError, "Get balance data fail");

  const columns: ColumnsType<GetAllVendorDataType["data"]["data"][0]> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Batch Code",
      dataIndex: "disbursement_batch_code",
      width: 130,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Batch Name",
      dataIndex: "disbursement_batch_name",
      width: 130,
      render: (val) => (val ? val : "-"),
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 130,
      align: "center",
      render: (val) => addCommaInNumber(val ? val : 0) + " BDT",
    },
    {
      title: "Pending Count",
      dataIndex: "pending_count",
      width: 130,
      align: "center",
      render: (val) => (val ? val : 0),
    },
    {
      title: "Success Count",
      dataIndex: "success_count",
      width: 130,
      align: "center",
      render: (val) => (val ? val : 0),
    },
    {
      title: "Failed Count",
      dataIndex: "failed_count",
      width: 130,
      align: "center",
      render: (val) => (val ? val : 0),
    },
    {
      title: "Action",
      align: "center",
      dataIndex: "disbursement_batch_code",
      render: (val) => (
        <Space size={8}>
          <Link
            to={`/admin/sheba-pay-wallet/payroll-disbursement/batch-code/${val}`}
          >
            <Button
              type="default"
              size="small"
              className=" bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex justify-center items-center gap-0.5 overflow-hidden"
              icon={<OrangeEyeIcon />}
            >
              <span className="justify-start text-orange-500 text-sm font-medium font-['Inter'] leading-normal">
                Open
              </span>
            </Button>
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Vendor Payment" backLink="/admin/sheba-pay-wallet">
        {open?.type === "IMPORT" && (
          <PayrollImportModal
            open={open.open}
            isBatchName={true}
            // data={vendorDetails?.data?.count! + 1}
            handleClose={handleClose}

            // reRender={reRender}
            // uploadedCount={}
          />
        )}

        {isCompanyDetailsLoading ? (
          <Loader />
        ) : role === "all" && companyDetails?.data ? (
          <Card style={{ width: "100%", marginBottom: "25px" }}>
            <div className="flex justify-between items-center">
              <div className="flex justify-start items-center gap-2">
                <img
                  src={companyDetails?.data?.logo || AvatarImage}
                  alt=""
                  className="w-14 h-14 rounded-full"
                />
                <div className="ml-2">
                  <div className="text-blue-500 text-lg font-semibold font-['Inter'] leading-normal">
                    {companyDetails?.data?.company_name}
                  </div>
                  <p className="text-blue-500 text-sm font-medium font-['Inter'] leading-tight">
                    Wallet No: {companyDetails?.data?.wallet_number || "N/A"}
                  </p>
                </div>
              </div>

              {isBalanceCheckLoading ? (
                <Spin />
              ) : user?.data?.company_id ? (
                <BalanceSlide>
                  {addCommaInNumber(
                    Math.round(balanceCheck?.data?.data?.Amount || 0)
                  )}
                  BDT
                </BalanceSlide>
              ) : null}
            </div>
          </Card>
        ) : null}

        <CustomTable
          loading={isLoading}
          limit={limit}
          page={page}
          columns={columns}
          hideRowSelect
          // total={data?.data?.totalCount}
          dataSource={addKeyInArray(data?.data?.data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              {/* {role === "maker" ? (
                <Button
                  onClick={() => handleOpen({ type: "IMPORT" })}
                  type="default"
                  className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                  icon={
                    <div className="w-4 h-4 flex justify-center items-center">
                      <PayrollImportOutlined />
                    </div>
                  }
                >
                  <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                    Import
                  </span>
                </Button>
              ) : null} */}

              <Button
                onClick={() => handleOpen({ type: "IMPORT" })}
                type="default"
                className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                icon={
                  <div className="w-4 h-4 flex justify-center items-center">
                    <PayrollImportOutlined />
                  </div>
                }
              >
                <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                  Import
                </span>
              </Button>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
